"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITagEntityToITag = void 0;
var ITagEntityToITag = function (e) { var _a; return ({ id: e.id, title: e.title, icon: (_a = e.icon) === null || _a === void 0 ? void 0 : _a.url }); };
exports.ITagEntityToITag = ITagEntityToITag;
